<template>
  <div v-if="item">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          <span>Status</span>
          <span class="margin-left-10">
            <i
              :class="{
                'fa fa-check has-text-success':
                  item.vps.stepCompleted === -1 && item.vps.state === 'Online',
                'fas fa-clock has-text-info':
                  (item.vps.stepCompleted !== -1 &&
                    item.vps.stepRunning !== -1) ||
                  item.vps.state !== 'Online',
                'fas fa-times has-text-danger':
                  item.vps.stepError &&
                  item.vps.stepCompleted !== -1 &&
                  item.vps.stepRunning === -1,
              }"
            ></i>
          </span>
          <span v-if="autoUpdating" class="margin-left-10 is-size-7 is-italic"
            >(auto-updating information)</span
          >
        </p>
      </header>
      <div class="card-content">
        <div class="content">
          <div class="table-container">
            <table class="table">
              <thead></thead>
              <tbody v-if="item.vps">
                <tr>
                  <td>Status</td>
                  <td
                    :class="{
                      'has-text-weight-bold has-text-info':
                        item.vps.state !== 'Online',
                      ' has-text-success': item.vps.state === 'Online',
                    }"
                  >
                    {{ item.vps.state }}
                  </td>
                </tr>

                <tr>
                  <td>Service URL</td>
                  <td>
                    <a
                      :href="
                        `http://app.${item.vps.subdomain}.${$helpers.vpsDomain}`
                      "
                      target="_blank"
                    >
                      app.{{ item.vps.subdomain }}.{{ $helpers.vpsDomain }}
                      <span>
                        <i
                          v-if="!appstatus"
                          class="fa fa-hourglass-start has-text-info"
                        ></i>
                      </span>
                      <span>
                        <i
                          v-if="appstatus"
                          :class="{
                            'fa fa-check has-text-success':
                              appstatus.api.http && appstatus.app.http,
                            'fa fa-times has-text-danger':
                              !appstatus.api.http || !appstatus.app.http,
                          }"
                        ></i>
                      </span>
                      <span>
                        <i
                          v-if="
                            appstatus &&
                              appstatus.api.http &&
                              appstatus.app.http &&
                              (!appstatus.api.https || !appstatus.app.https)
                          "
                          class="fa fa-unlock has-text-success has-text-danger margin-left-10"
                        ></i>
                      </span>
                    </a>
                  </td>
                </tr>

                <!-- <tr
                  v-if="
                    item.vps.state === 'Online' &&
                      item.vps.stepCompleted === -1 &&
                      item.vps.installation === 'docker'
                  "
                >
                  <td>
                    <span v-if="!isMgmtEnabled">Docker management</span>
                    <a
                      v-else
                      :href="
                        `http://manage.${item.vps.subdomain}.${$helpers.vpsDomain}`
                      "
                      target="_blank"
                      >Docker management</a
                    >
                  </td>
                  <td>
                    <a
                      v-if="!isMgmtEnabled"
                      class="button is-small is-rounded is-success is-outlined"
                      :class="{
                        'is-loading': item.vps.task === 'setDockerManagement',
                      }"
                      @click="setManagementVisible = true"
                    >
                      Enable
                    </a>
                    <a
                      v-else
                      class="button is-small is-rounded is-danger"
                      :class="{
                        'is-loading': item.vps.task === 'setDockerManagement',
                      }"
                      @click="setManagementVisible = true"
                    >
                      Disable
                    </a>
                  </td>
                </tr> -->

                <tr>
                  <td>IP address</td>
                  <td>{{ item.vps.ip || "n/a" }}</td>
                </tr>

                <tr v-if="item.vps.cpu">
                  <td>Harware</td>
                  <td>
                    {{ item.vps.cpu || "n/a" }} cores
                    <span v-if="item.vps.memory"
                      >,
                      {{
                        item.vps.memory.toString().substring(0, 1) +
                          " GB RAM" || "n/a"
                      }}</span
                    >

                    <span v-if="item.vps.disk"
                      >, {{ item.vps.disk + " GB storage" || "n/a" }}</span
                    >
                  </td>
                </tr>

                <tr>
                  <td>"root"-user password</td>
                  <td>
                    <a
                      v-if="!password"
                      :disabled="
                        item.vps.state !== 'Online' ||
                          item.vps.stepCompleted !== -1 ||
                          generatePasswordLoading
                      "
                      class="button is-small is-rounded is-success"
                      :class="{ 'is-loading': generatePasswordLoading }"
                      @click="confirmVisible = true"
                    >
                      Generate
                    </a>
                    <span v-if="password" class="is-size-7">
                      {{ password }}
                    </span>
                  </td>
                </tr>

                <tr v-if="item.vps.deployifyPassword">
                  <td>"deployify"-user password</td>
                  <td>
                    <i
                      v-if="!showDeployifyPassword"
                      class="fa fa-eye has-text-info"
                      @click="showDeployifyPassword = !showDeployifyPassword"
                    ></i>

                    <span
                      v-if="item.vps.deployifyPassword && showDeployifyPassword"
                      class="is-size-7"
                      >{{ item.vps.deployifyPassword || "n/a" }}</span
                    >

                    <i
                      v-if="showDeployifyPassword"
                      class="fa fa-eye-slash has-text-info margin-left-10"
                      @click="showDeployifyPassword = !showDeployifyPassword"
                    ></i>
                  </td>
                </tr>

                <tr v-if="item.vps.stepCompleted === -1">
                  <td>Automatic security updates</td>
                  <td>
                    <span class="has-text-success">Active</span>
                    <span class="is-size-7 margin-left-10"
                      >(will reboot 02:00 local server time, if needed)</span
                    >
                  </td>
                </tr>

                <!-- <tr
                  v-if="
                    item.vps.stepCompleted === -1 &&
                      item.vps.state === 'Online' &&
                      openPorts &&
                      item.vps.installation === 'docker'
                  "
                >
                  <td>Open firewall ports</td>
                  <td>
                    <ul>
                      <li v-for="port of openPorts" :key="port">{{ port }}</li>
                    </ul>
                  </td>
                </tr> -->

                <!-- <tr
                  v-if="
                    openPorts &&
                      item.vps.state === 'Online' &&
                      item.vps.stepCompleted === -1
                  "
                >
                  <td>
                    Docker management firewall rule (port 9000)
                  </td>
                  <td>
                    <a
                      v-if="!isPortOpen(9000)"
                      class="button is-small is-rounded is-success is-outlined"
                      :class="{ 'is-loading': openPortSaving }"
                      @click="openPortVisible = true"
                    >
                      Open
                    </a>
                    <a
                      v-else
                      class="button is-small is-rounded is-danger"
                      :class="{ 'is-loading': closePortSaving }"
                      @click="closePortVisible = true"
                    >
                      Close
                    </a>
                  </td>
                </tr> -->
              </tbody>
            </table>
          </div>

          <div
            v-if="
              hoursOldVps < 72 &&
                item.vps.state === 'Online' &&
                item.vps.stepCompleted === -1 &&
                appstatus &&
                !appstatus.api.http &&
                !appstatus.app.http
            "
            class="notification is-warning content"
          >
            <p>Deployify may appear unreachable if:</p>
            <ul>
              <li>
                The domain is not globally updated. This can take up to 72
                hours, but most likely within one hour.
              </li>
              <li>Root password is being generated.</li>
            </ul>
          </div>

          <div
            v-if="
              hoursOldVps < 72 &&
                item.vps.state === 'Online' &&
                item.vps.stepCompleted === -1 &&
                appstatus &&
                appstatus.api.https &&
                appstatus.app.https
            "
            class="notification is-info content"
          >
            <h2 class="has-text-white">Getting SSL/HTTPS/Not private error?</h2>
            <p>
              If the service was visited before the service creation was
              complete, you may get an "Not private" error.
            </p>

            <p>
              <b>
                Try clearing the browsers cache or use a private window to
                resolve this issue.</b
              >
            </p>
          </div>

          <p
            v-if="
              item.vps.stepRunning &&
                item.vps.stepCompleted !== -1 &&
                item.vps.stepRunning !== -1
            "
            class="notification is-info"
          >
            Running step: {{ item.vps.stepRunning }}
            <br />
            {{ item.vps.stepMessage }}
            ...
          </p>

          <div
            v-if="
              item.vps.stepError &&
                item.vps.stepCompleted !== -1 &&
                item.vps.stepRunning === -1
            "
          >
            <p class="notification is-danger">
              {{ item.vps.stepMessage }} ...
              <br />
              {{ item.vps.stepError }}
            </p>
            <a class="button is-info" @click="RerunConfig()">Retry</a>
          </div>
        </div>
      </div>
    </div>

    <Confirm
      v-model="confirmVisible"
      title="Generate root password"
      @confirmed="GeneratePassword()"
    >
      <p>
        The server will be unresponsive for a few minutes when performing this
        task.
      </p>
    </Confirm>

    <Confirm
      v-if="openPortVisible"
      v-model="openPortVisible"
      title="Firewall rule"
      :confirmBtn="{ css: 'is-success' }"
      @confirmed="OpenPort(9000)"
    >
      <div class="content">
        <div class="notification is-warning">
          <p>
            This is only for debugging and when
            <a
              :href="
                `http://manage.${item.vps.subdomain}.${$helpers.vpsDomain}`
              "
              target="_blank"
              >Docker management</a
            >
            does not work. The connection will not be insecure (no HTTPS), and
            the service has root access. This is a major security risk!
          </p>
        </div>

        <p>
          This action will add a firewall rule to allow port 9000, to be able to
          reach the Docker management on this url:
          <a
            :href="
              `http://manage.${item.vps.subdomain}.${$helpers.vpsDomain}:9000`
            "
            target="_blank"
            >{{
              `http://manage.${item.vps.subdomain}.${$helpers.vpsDomain}:9000`
            }}</a
          >
        </p>
      </div>
    </Confirm>

    <Confirm
      v-if="closePortVisible"
      v-model="closePortVisible"
      title="Firewall rule"
      @confirmed="ClosePort(9000)"
    >
      <div class="content">
        <p>
          This action will remove the firewall rule to allow connections to the
          Docker management (port 9000).
        </p>
      </div>
    </Confirm>

    <Confirm
      v-if="setManagementVisible"
      v-model="setManagementVisible"
      title="Docker management"
      :confirmBtn="{ css: 'is-success' }"
      @confirmed="SetDockerEnabled(!isMgmtEnabled)"
    >
      <div class="content">
        <p>
          This action {{ !isMgmtEnabled ? "enables" : "disables" }} the ability
          to reach Docker management externally:
          <a
            :href="`http://manage.${item.vps.subdomain}.${$helpers.vpsDomain}`"
            target="_blank"
            >{{ `manage.${item.vps.subdomain}.${$helpers.vpsDomain}` }}</a
          >
        </p>

        <p>This will take a while.</p>

        <p v-if="!isMgmtEnabled" class="notification warning">
          Only use this for debugging. The management service has VPS root
          access and is a major security risk!
        </p>
      </div>
    </Confirm>
  </div>
</template>

<script>
import Confirm from "@/components/main/Confirm.vue";
export default {
  components: { Confirm },

  data() {
    return {
      setManagementVisible: false,
      openPortSaving: false,
      closePortSaving: false,
      confirmVisible: false,
      openPortVisible: false,
      closePortVisible: false,
      autoUpdating: false,
      item: null,
      password: null,
      generatePasswordLoading: false,
      showRootPassword: false,
      showDeployifyPassword: false,
      appstatus: null,
      openPorts: null,
      destroyed: false,
    };
  },
  computed: {
    isPortOpen() {
      return (port) => {
        if (this.openPorts)
          return this.openPorts.some((x) => x === port.toString());
        else return false;
      };
    },
    isMgmtEnabled: function() {
      if (this.item && this.item.vps)
        return this.item.vps.dockerManagementEnabled;
      else return false;
    },
    hoursOldVps: function() {
      if (this.item) {
        return (new Date() - new Date(this.item.vps.timeCreated)) / 36e5;
      } else {
        return -1;
      }
    },
  },
  beforeDestroy() {
    this.destroyed = true;
  },
  async created() {
    if (this.$route.params.uid) {
      await this.GetItem();
      await this.GetStatus();
      this.MonitorAppStatus();

      if (this.item && !this.autoUpdating) this.InitFetchLoop();
      if (this.item && this.item.vps && this.item.vps.stepCompleted === -1) {
        this.openPorts = await this.GetOpenPorts();

        if (this.item.vps.task) this.InitTaskCheck(this.item.vps.task);
      }
    }
  },
  methods: {
    async GeneratePassword() {
      try {
        this.generatePasswordLoading = true;
        const res = await this.$helpers.PostApi("vps/password", {
          uid: this.item.vps.uid,
          serverId: this.item.vps.serverId,
        });

        this.password = res;

        this.$helpers.ShowStatus(
          "New password is generated. It could take a few minutes until this task is complete.",
          5000,
          "info"
        );
      } catch {
        this.$helpers.ShowStatus(
          "Could not generate password.",
          5000,
          "warning"
        );
      }

      this.generatePasswordLoading = false;

      if (!this.autoUpdating) {
        await this.InitFetchLoop(true, this.GetStatus, 10000);
      }
    },

    async GetItem() {
      try {
        const res = await this.$helpers.PostApi("get/vps", {
          uid: this.$route.params.uid,
        });

        if (res.length != 0) {
          this.$set(this, "item", res[0]);
        }
      } catch {}
    },

    async GetStatus() {
      try {
        if (this.item && this.item.vps) {
          const res = await this.$helpers.PostApi("vps/status", {
            uid: this.item.vps.uid,
            serverId: this.item.vps.serverId,
          });

          if (res) {
            this.$set(this.item.vps, "state", res.state);
            this.$set(this.item.vps, "detailed_state", res.detailed_state);
          }
        }
      } catch {}
    },
    async InitFetchLoop(force, fn = this.GetItem, wait = 6000) {
      try {
        if (this.destroyed) return;

        if (
          (this.item.vps.stepCompleted === -1 &&
            this.item.vps.state !== "Online") ||
          force
        ) {
          this.autoUpdating = true;

          await this.GetStatus();
          await this.Wait(15000);
          await this.InitFetchLoop(force, fn, wait);
        } else if (
          this.item.vps.stepCompleted !== -1 ||
          this.item.vps.state !== "Online"
        ) {
          this.autoUpdating = true;

          await this.GetItem();
          await this.Wait(5000);
          await this.InitFetchLoop(force, fn, wait);
        } else {
          this.autoUpdating = false;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async MonitorAppStatus() {
      while (!this.destroyed) {
        try {
          const appstatus = await this.$helpers.PostApi("vps/appstatus", {
            uid: this.$route.params.uid,
          });

          this.$set(this, "appstatus", appstatus);
        } catch (err) {
          console.error(err);
        }

        await this.Wait(6000);
      }
    },

    async RerunConfig() {
      this.item.vps.stepRunning = this.item.vps.stepCompleted + 1;
      await this.$helpers.PostApi("vps/config", {
        uid: this.$route.params.uid,
      });

      if (!this.autoUpdating) {
        await this.InitFetchLoop();
      }
    },

    async SetDockerEnabled(enable) {
      try {
        await this.$helpers.PostApi("vps/set/management", {
          uid: this.$route.params.uid,
          enable,
        });

        this.$set(this.item.vps, "task", "setDockerManagement");
        this.InitTaskCheck("setDockerManagement");
      } catch (err) {
        this.$helpers.ShowStatus(
          `Unknown error, could not change Docker management config.`,
          5000,
          "warning"
        );
      }
    },

    GetOpenPorts() {
      try {
        return this.$helpers.PostApi("vps/get/open/ports", {
          uid: this.$route.params.uid,
        });
      } catch (err) {
        console.log("Could not get open ports:", err.message);
      }
    },

    async OpenPort(port) {
      if (!this.openPortSaving) {
        try {
          this.openPortSaving = true;
          await this.$helpers.PostApi("vps/open/port", {
            uid: this.$route.params.uid,
            port: port,
          });

          this.openPorts = await this.GetOpenPorts();
        } catch (err) {
          console.log(err);
          this.$helpers.ShowStatus(
            `Unknown error, could not open the port ${port}.`,
            5000,
            "warning"
          );
        }

        this.openPortSaving = false;
      }
    },

    async ClosePort(port) {
      if (!this.closePortSaving) {
        try {
          this.closePortSaving = true;
          await this.$helpers.PostApi("vps/close/port", {
            uid: this.$route.params.uid,
            port: port,
          });

          this.openPorts = await this.GetOpenPorts();
        } catch (err) {
          console.log(err);
          this.$helpers.ShowStatus(
            `Unknown error, could not close the port ${port}.`,
            5000,
            "warning"
          );
        }

        this.closePortSaving = false;
      }
    },

    Wait(time) {
      return new Promise((resolve) => {
        setTimeout(resolve, time);
      });
    },

    async InitTaskCheck(task) {
      while (!this.destroyed) {
        try {
          await this.GetItem();
          if (
            this.item &&
            this.item.vps &&
            (!this.item.vps.task || this.item.vps.task !== task)
          ) {
            break;
          }
        } catch (error) {}

        await this.Wait(5000);
      }
    },
  },
};
</script>
